import Backbone from 'backbone';
import Promise from 'bluebird';
import _ from 'underscore';

/**
 * Representing the base step view
 * - Empty title
 * - Hooked up with lifecycle classes doing nothing
 * - Empty body
 * - Default actions
 */
export class BaseStepView extends Backbone.View {
  get title() {
    return { text: '' };
  }

  /**
   * Do something before the step view is disappear from the viewport
   *
   * @returns {void}
   */
  willHide() {
    // do nothing
  }

  /**
   * Do something before the step view is displayed on the viewport
   *
   * @returns {void}
   */
  willShow() {
    // do nothing
  }

  /**
   * Hooked up with the "save" action.
   *
   * @returns {promise} resolve means saved successfully. Reject is the opposite.
   */
  save() {
    return Promise.resolve();
  }

  /**
   * Hooked up with the "cancel" action.
   *
   * @returns {promise} terminate the workflow by resolving the promise.
   */
  cancel() {
    return Promise.resolve();
  }

  /**
   * Handler of the "next" action
   *
   * @returns {promise|boolean}
   * A promise of true | true - Ok to go next
   * A promise of false | false - No validataion failed or other similar user errors.
   * A rejected promise | throws errors - Exceptions or failures.
   */
  wizardShouldGoNext() {
    return true;
  }

  /**
   * Handler of the "next" action
   *
   * @returns {promise|boolean}
   * A promise of true | true - Ok to go next
   * A promise of false | false - No validataion failed or other similar user errors.
   * A rejected promise | throws errors - Exceptions or failures.
   */
  wizardShouldGoBack() {
    return true;
  }

  /**
   *
   * @param {object} [state] override current state with this object.
   * @returns {void}
   */
  setState(state) {
    this.state = state;
  }

  /**
   *
   * @param {object|function} [patch] the state you want to patch or the function you want to apply
   * to patch current state
   * @returns {void}
   */
  patchState(patch) {
    const patchFunction = _.isFunction(patch) ? patch : state => _.defaults({}, patch, state);

    return this.setState(patchFunction(this.getState()));
  }

  /**
   * get current step's states
   *
   * @returns {object} the current state
   */
  getState() {
    return this.state;
  }
}
